const apiBaseUrlOverride = import.meta.env.API_BASE_URL;
let apiBaseUrl: string;

if (apiBaseUrlOverride) {
  apiBaseUrl = apiBaseUrlOverride;
} else {
  // Load config based on ENVIRONMENT variable (defaults to 'local')
  const environment = import.meta.env.ENVIRONMENT || 'local';
  let config: { API_BASE_URL: string };

  switch (environment) {
    case 'production':
      config = (await import('../config/production')).default;
      break;
    case 'staging':
      config = (await import('../config/staging')).default;
      break;
    case 'local':
      config = (await import('../config/local')).default;
      break;
    default:
      throw new Error(`Invalid environment: ${environment}`);
  }

  apiBaseUrl = config.API_BASE_URL;
}

export const API_BASE_URL = apiBaseUrl;
